export default "__VITE_ASSET__Dg5NYuod__"